import { jsx } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { forwardRef } from "react";
import { useSlotProps } from "../../../base/index.js";
import { useToolbarView } from "../hooks/useToolbarView.js";
import { toolbarModalDrawerName } from "./classes.js";
import { Root } from "./components/Root.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const ToolbarModalDrawer = forwardRef(
  function ToolbarModalDrawer2(inProps, ref) {
    const props = useThemeProps({
      name: toolbarModalDrawerName,
      props: inProps
    });
    const {
      children,
      className = "",
      classes,
      components,
      componentsProps,
      onOpen,
      sx,
      testId = `${toolbarModalDrawerName}-root`,
      value,
      ...rest
    } = props;
    const { handleClose, handleOpen, isOpen, railWidth, railPosition } = useToolbarView({
      onOpen,
      value
    });
    const offsetX = (railPosition?.x ?? 0) + railWidth;
    const ownerState = { classes, offsetX, open: isOpen };
    const utilityClasses = useUtilityClasses(ownerState);
    const rootSlotProps = useSlotProps({
      className: `${className} ${utilityClasses.root}`,
      elementType: Root,
      externalSlotProps: componentsProps?.root,
      ownerState,
      additionalProps: {
        "data-testid": testId,
        "data-tidal": toolbarModalDrawerName,
        anchor: "left",
        as: components?.Root,
        elevation: 7,
        onOpen: handleOpen,
        open: isOpen,
        ref,
        sx,
        variant: "temporary",
        ...rest,
        onClose: handleClose
      }
    });
    return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children });
  }
);
export {
  ToolbarModalDrawer
};
//# sourceMappingURL=ToolbarModalDrawer.js.map
